import { render, staticRenderFns } from "./editprice.vue?vue&type=template&id=597e6a10&"
import script from "./editprice.vue?vue&type=script&lang=ts&"
export * from "./editprice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editprice.vue"
export default component.exports